<template>
    <div class="account-management">
      <div class="header">
        <div class="search-container">
          <input v-model="searchQuery" type="text" placeholder="搜索账号" class="search-input" />
          <button @click="searchAccounts" class="search-button">搜索</button>
        </div>
        <button @click="addAccount" class="add-button">添加账号</button>
      </div>
      <div class="account-list">
        <div v-for="account in accounts" :key="account.id" class="account-item">
          <div class="account-info">
            <div class="info-item">
              <label>账号：</label>
              <span>{{ account.mobile }}</span>
            </div>
            <div class="info-item">
              <label>状态：</label>
              <span>{{ account.status === '0' ? '已禁用' : '正常' }}</span>
            </div>
            <div class="info-item">
              <label>创建时间：</label>
              <span>{{ formatTime(account.createTime) }}</span>
            </div>
          </div>
          <div class="actions">
            <button @click="queryLoginRecord('/mobileLoginRecord',account.mobile)" class="action-button">
              登录记录管理
            </button>
            <button @click="toggleAdmin(account)" class="action-button">
              {{ account.isAdmin === '1' ? '取消管理员' : '设为管理员' }}
            </button>
            <button @click="disableAccount(account)" class="action-button">
              {{ account.status === '0' ? '启用' : '禁用' }}
            </button>
            <button @click="logoff(account)" class="action-button">
              退出登录
            </button>
          </div>
        </div>
      </div>
      <button @click="goToHome" class="return-home-button">返回管理页</button>
    </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';

export default {
  name: 'UserManage',
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();

    const searchQuery = ref('');
    const accounts = ref([]);

    // 新增时间格式化方法
    const formatTime = (timestamp) => {
      if (!timestamp) return '-'
      return new Date(timestamp).toLocaleString()
    }

     const addAccount = () => {
        router.push('/mobileAddUser');
    };

    const queryLoginRecord = (path, mobile) => {
      router.push({ 
        path, 
        query: { mobile } 
      });
    };
    // const queryLoginRecord = (mobile) => {
    //       router.push({name:"LoginRecord",params:{mobile:mobile}})
    // };

    const goToHome = () => {
      router.push('/manage');
    };

    const toggleAdmin = (account) => {
        let url = '/login/updateUser';
        const isAdmin = account.isAdmin === '1' ? '0' : '1';
        proxy.$tools.request(url,
        {reqBody:{mobileNo:account.mobile,isAdmin:isAdmin}}
      ).then(response =>{
        const code = response.data.rspHead.returnCode;
        if(code === '00000000'){
            ElMessage.success('操作成功');
            searchAccounts();
        }else{
            ElMessage.error('系统异常，请联系管理员'+response.data.rspHead.returnMsg);
        }
      }) .catch(error => {
          // 处理错误情况
          ElMessage.error('系统异常，请联系管理员'+error); 
        });
    };

    const disableAccount = (account) => {
        let url = '/login/updateUser';
        const status = account.status === '1' ? '0' : '1';
        proxy.$tools.request(url,
        {reqBody:{mobileNo:account.mobile,status:status}}
      ).then(response =>{
        const code = response.data.rspHead.returnCode;
        if(code === '00000000'){
            ElMessage.success('操作成功');
            searchAccounts();
        }else{
            ElMessage.error('系统异常，请联系管理员'+response.data.rspHead.returnMsg);
        }
      }) .catch(error => {
          // 处理错误情况
          ElMessage.error('系统异常，请联系管理员'+error); 
        });
    };

    const logoff = (account) => {
        let url = '/login/logoff';
        proxy.$tools.request(url,
        {reqBody:{mobileNo:account.mobile}}
      ).then(response =>{
        const code = response.data.rspHead.returnCode;
        if(code === '00000000'){
            ElMessage.success('操作成功');
            searchAccounts();
        }else{
            ElMessage.error('系统异常，请联系管理员'+response.data.rspHead.returnMsg);
        }
      }) .catch(error => {
          // 处理错误情况
          ElMessage.error('系统异常，请联系管理员'+error); 
        });
    };

    const searchAccounts = async () => {
        let url = '/login/queryUser';
        proxy.$tools.request(url,
        {reqBody:{mobileNo:searchQuery.value}}
      ).then(response =>{
        const code = response.data.rspHead.returnCode;
        if(code === '00000000'){
            accounts.value = response.data.rspBody.userList;
        }else{
            ElMessage.error('系统异常，请联系管理员'+response.data.rspHead.returnMsg);
        }
      }) .catch(error => {
          // 处理错误情况
          ElMessage.error('系统异常，请联系管理员'+error); 
        });
    };

    const checkLogin = () => {
      let token = localStorage.getItem("token"); // 从缓存中获取token
        token = token || null;
      if (token) {
        // 如果有token，调用后端接口验证
        const url = "/login/checkLoginStatus";
        proxy.$tools
          .request(url, { reqBody: {} })
          .then((response) => {
            const returnCode = response.data.rspHead.reurnCode;
            if (!"000000" === returnCode) {
              router.push("/error");
            }
            const status = response.data.rspBody.status;
            if ("0" === status) {
              router.push("/appLogin");
            } 
          })
          .catch((error) => {
            // 处理错误情况
            console.error(error);
          });
      } else {
        // 如果没有token，重定向到登录页面
        router.push("/appLogin");
      }
      
      // 这里可以添加查看施工图的逻辑
  
    };

  onMounted(() => {
      checkLogin();
  });

    // 保持原有方法不变...
    // [此处保持原有的addAccount、toggleAdmin等方法实现]

    return {
      searchQuery,
      accounts,
      formatTime,
      addAccount,
      toggleAdmin,
      searchAccounts,
      disableAccount,
      logoff,
      goToHome,
      queryLoginRecord
    };
  },
};
</script>

<style scoped>
.account-management {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.account-item {
  display: flex;
  flex-direction: column;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 12px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.account-info {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.info-item label {
  color: #909399;
  margin-right: 8px;
}

.info-item span {
  color: #606266;
  font-weight: 500;
}

.actions {
  display: flex;
  gap: 10px;
}

.action-button {
  padding: 6px 12px;
  font-size: 13px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .account-info {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .actions {
    flex-wrap: wrap;
  }
  
  .action-button {
    flex: 1 0 45%;
    margin: 4px;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-container {
  display: flex;
  align-items: center;
}

.search-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  flex: 1;
  margin-right: 10px;
}

.search-button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}

.search-button:hover {
  background-color: #007bff;
}

.add-button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}

.add-button:hover {
  background-color: #0056b3;
}

.account-list {
  display: flex;
  flex-direction: column;
}

.account-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
}

.actions {
  display: flex;
}

.action-button {
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  margin-left: 10px;
}

.action-button:hover {
  background-color: #0056b3;
}

.return-home-button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  margin-top: 20px;
}

.return-home-button:hover {
  background-color: #0056b3;
}

@media (max-width: 600px) {
  .header {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-container {
    flex-direction: column;
    width: 100%;
    margin-bottom: 10px;
  }

  .search-input {
    margin-bottom: 10px;
  }
}
/* 保持原有其他样式不变... */
</style>
